import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";

interface MyTimesheetNewRequestDialogDurationProps {
  formik: {
    values: {
      startTime?: string | Date;
      endTime?: string | Date;
    };
  };
}

export const MyTimesheetNewRequestDialogDuration = ({
  formik,
}: MyTimesheetNewRequestDialogDurationProps) => {
  const { t } = useTranslation();
  let duration;

  if (formik.values.startTime && formik.values.endTime) {
    let start = new Date(formik.values.startTime);
    let end = new Date(formik.values.endTime);
    let elapsed = end.getTime() - start.getTime();
    let seconds = Math.floor(elapsed / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);
    let hoursStr = hours.toString().padStart(2, "0");
    let minutesStr = (minutes - hours * 60).toString().padStart(2, "0");
    duration = `${hoursStr}:${minutesStr}`;
  } else {
    duration = "00:00";
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      width="179px"
      height="112px"
      padding="20px 6px 12px 7px"
      style={{
        backgroundColor: "#E3E5E5",
        borderRadius: "4px",
      }}
    >
      <Typography variant="h2" color="#CC0033" style={{ fontWeight: "400" }}>
        {duration}
      </Typography>
      <Box height="12px" />
      <Typography
        variant="body1"
        style={{
          color: "#4D4D4D",
        }}
      >
        {t("MY_TIME_WORKING_TIME")}
      </Typography>
    </Box>
  );
};

export default MyTimesheetNewRequestDialogDuration;
